import { LaneTypes } from "../../../constants";
import { DetectionVehicleTypes } from "../../../enums/vehicleType";
import { MetadataLaneDataDetection } from "../../../interfaces";
import { detectionColors } from "../../../theme/colors";

export const routeLaneTypesToString = (laneTypes: number[] = []) => {
  return laneTypes.map((laneTypeId) => LaneTypes[laneTypeId]);
};

export const getDetectionColor = (detection: MetadataLaneDataDetection, isViolation: boolean) => {
  if (isViolation) {
    switch (detection.det_class) {
      case DetectionVehicleTypes.BUS:
        return detectionColors.violation[DetectionVehicleTypes.BUS];
      case DetectionVehicleTypes.CAR:
        return detectionColors.violation[DetectionVehicleTypes.CAR];
      case DetectionVehicleTypes.TRUCK:
        return detectionColors.violation[DetectionVehicleTypes.TRUCK];
      default:
        return detectionColors.violation.generic;
    }
  } else {
    switch (detection.det_class) {
      case DetectionVehicleTypes.BUS:
        return detectionColors.detection[DetectionVehicleTypes.BUS];
      case DetectionVehicleTypes.CAR:
        return detectionColors.detection[DetectionVehicleTypes.CAR];
      case DetectionVehicleTypes.TRUCK:
        return detectionColors.detection[DetectionVehicleTypes.TRUCK];
      default:
        return detectionColors.detection.generic;
    }
  }
};
